<template>
  <div>
    <FilterTab>
      <template v-slot:body>
        <div class="col-sm-6 col-md-2"></div>
      </template>
      <template v-slot:button2>
        <button class="edit_table_data font_detail" @click="goBack">
          <i class="fas fa-arrow-left"></i
          ><span class="mx-1 bold">Go Back</span>
        </button>
      </template>
      <template v-slot:button1>
        <button
          class="edit_table_data font_detail"
          @click="exportTable('xlsx')"
        >
          <i class="fas fa-download"></i><span class="mx-1 bold">Export</span>
        </button>
      </template>
    </FilterTab>
  </div>

  <div
    class="card h-100 mt-4"
    v-for="(itemValue, itemKey) in classWiseReport"
    :key="itemKey"
  >
    <div class="card-header text-center bg-white">
      <h5 class="mb-0 text-uppercase">{{ itemKey }}</h5>
    </div>
    <div class="card-body mt-0 py-0">
      <table-simple :id="itemKey">
        <template v-slot:header>
          <tr>
            <td class="font_detail">SL</td>
            <td class="font_detail">Ticket Date Time</td>

            <td class="font_detail">Ship Name</td>
            <td class="font_detail">Passenger Name</td>
            <td class="font_detail">Passenger Phone</td>
            <td class="font_detail">Boarding Place</td>
            <td class="font_detail">Dropping Place</td>
            <td class="font_detail">Seat Numbers</td>
            <td class="font_detail">Total Ticket</td>
            <td class="font_detail">Receivable Amount</td>
            <td v-if="agentWiseReport.discount" class="font_detail">
              Discount
            </td>
            <td class="font_detail">Issued By</td>
            <td class="font_detail" v-if="cancelledBy === 0">Cancelled By</td>
            <td class="font_detail" v-if="cancelledBy === 0">
              Cancellation Cause
            </td>
          </tr>
        </template>
        <template v-slot:body>
          <tr v-for="(item, index) in itemValue.totalReport" :key="index">
            <td class="font_detail">{{ index + 1 }}</td>
            <td class="font_detail">{{ dateFormat(item.ticketDateTime) }}</td>

            <td class="font_detail">{{ item.shipName }}</td>
            <td class="font_detail">{{ item.passengerName }}</td>
            <td class="font_detail">{{ item.passengerPhone }}</td>
            <td class="font_detail">{{ item.boardingPlace }}</td>
            <td class="font_detail">{{ item.droppingPoint }}</td>
            <td class="font_detail">
              {{ item.seatNumbers.replaceAll(",", ", ") }}
            </td>
            <td class="font_detail">{{ item.totalSeat }}</td>
            <td class="font_detail">
              {{ item.payable }}
            </td>
            <td v-if="agentWiseReport.discount" class="font_detail">
              {{ item.discount }}
            </td>
            <td class="font_detail">{{ item.issuedBy }}</td>
            <td class="font_detail" v-if="cancelledBy === 0">
              {{ item.cancelledBy }}
            </td>
            <td class="font_detail" v-if="cancelledBy === 0">
              {{ item.cancellationCause }}
            </td>
          </tr>
          <tr class="bg-dark text-white" v-if="summary">
            <td class="font_detail text-white"></td>
            <td class="font_detail text-white"></td>
            <td class="font_detail text-white"></td>
            <td class="font_detail text-white"></td>
            <td class="font_detail text-white"></td>
            <td class="font_detail text-white"></td>
            <td class="font_detail text-white"></td>
            <td class="font_detail text-white"></td>
            <td class="font_detail text-white">
              Total Ticket: {{ itemValue.totalTicket }}
            </td>
            <td class="font_detail text-white">
              Total Amount: {{ itemValue.totalAmount }} Taka
            </td>
            <td v-if="agentWiseReport.discount" class="font_detail text-white">
              Total Discount: {{ itemValue.totalDiscount }} Taka
            </td>
            <td class="font_detail text-white"></td>
            <td class="font_detail text-white" v-if="cancelledBy === 0"></td>
            <td class="font_detail text-white" v-if="cancelledBy === 0"></td>
          </tr>
        </template>
      </table-simple>
    </div>
  </div>
</template>


<script>
import { reactive } from "@vue/reactivity";
import { ref, onBeforeMount, inject } from "vue";
import store from "@/store";
import moment from "moment";

export default {
  name: "AgentDetails",
  components: {},
  props: {
    counterManId: String,
    fromDate: String,
    toDate: String,
    status: Number,
    discount: [Number, String],
  },
  emits: ["backToShipWiseReport"],
  setup(props, { emit }) {
    let counterManId = ref(props.counterManId);
    let fromDate = ref(props.fromDate);
    let toDate = ref(props.toDate);
    let cancelledBy = ref(props.status);

    let totalAmountSeat = ref(0);
    let totalSeat = ref(0);
    let totalDiscount = ref(0);
    const showLoader = inject("showLoader");
    const hideLoader = inject("hideLoader");
    const exportExcel = inject("exportExcel");

    let summary = ref(false);

    let agentWiseReport = reactive({
      ticketType: "SEAT",
      countermanId: counterManId.value,
      fromDate: fromDate.value,
      toDate: toDate.value,
      direction: "",
      status: props.status,
      discount: props.discount,
      page: 1,
      limit: 10,
    });

    let classWiseReport = reactive({});

    const dateFormat = (date) => {
      return moment(String(date))
        .utcOffset(6, false)
        .format("DD-MMM-yyyy hh:mm A");
    };

    const getAgentDetails = () => {
      showLoader();
      store
        .dispatch("getAgentWiseSeatDetailsOwner", agentWiseReport)
        .then((response) => {
          if (response.length !== 0) {
            classifyByClassName(response);
          } else {
            summary.value = false;
          }
          hideLoader();
        })
        .catch(() => hideLoader());
    };

    const classifyByClassName = (reports) => {
      reports.forEach((report) => {
        if (report.seatClassName in classWiseReport) {
          classWiseReport[report.seatClassName].totalReport.push(report);
        } else {
          classWiseReport[report.seatClassName] = {
            totalReport: [],
            totalTicket: 0,
            totalAmount: 0,
            totalDiscount: 0,
          };
          classWiseReport[report.seatClassName].totalReport.push(report);
        }
      });
      seatDetailsdata();
      summary.value = true;
    };

    const seatDetailsdata = () => {
      for (const key in classWiseReport) {
        classWiseReport[key].totalReport.forEach((data) => {
          classWiseReport[key].totalAmount += data.payable;
          classWiseReport[key].totalTicket += data.totalSeat;
          classWiseReport[key].totalDiscount += data.discount;
        });
      }
    };

    const goBack = () => {
      emit("backToShipWiseReport", true);
    };

    const exportTable = (type) => {
      for (const key in classWiseReport) {
        exportExcel(
          type,
          key + "_Owner_AgentWise_Details_Report.",
          undefined,
          key
        );
      }
    };

    onBeforeMount(() => {
      getAgentDetails();
    });

    return {
      agentWiseReport,
      totalAmountSeat,
      goBack,
      exportTable,
      totalSeat,
      summary,
      cancelledBy,
      totalDiscount,
      dateFormat,
      classWiseReport,
    };
  },
};
</script>